import { Separator } from '@change/ds-core-ui';

import { PolicyInfo, PublicInput, ShouldSavePaymentMethodInput } from '../components';

import { useContainer } from './hooks/useContainer';
import { useFooterContainer } from './hooks/useFooterContainer';

const InnerPromoteFormFooterContainer: React.FC = () => {
	const {
		data: { displayed },
	} = useFooterContainer();

	if (!displayed) return null;

	return (
		<>
			<div className="flex flex-col gap-1">
				<ShouldSavePaymentMethodInput />
				<PublicInput />
			</div>
			<Separator className="my-0" />
			<div className="text-start">
				<PolicyInfo />
			</div>
			<Separator className="my-0" />
		</>
	);
};

export const PromoteFormFooterContainer: React.FC = () => {
	const {
		data: { displayed },
	} = useContainer();

	if (!displayed) return null;

	return <InnerPromoteFormFooterContainer />;
};
